/**
 * % 칸 — 정밀 요율(25.38461538)을 그대로 들고 있되, 칸이 좁아 평소엔 둘째 자리(25.38)로 보여 준다.
 * 누르면 전체 값 · 말풍선에도 전체 값.
 *
 * 왜: v2.286.0(개발요청 #8)부터 정산요율에 수수료를 직접 적으면 요율이 「수수료 ÷ 판매금액」(예: 25.3846153846%)으로
 *   정밀하게 저장되고, 정산서 작성 창·BOM 영업수수료 줄이 그 값을 깎지 않고 가져온다(9,900,000원이 9,898,200원이 되지 않게).
 *   그런데 그 칸들은 44~64px 라 「25.38461538」 이 앞 두세 글자만 보였다.
 */
import { useState } from 'react';

export function PctInput({
  value,
  onChange,
  className,
  ariaLabel,
}: {
  /** 지금 값 — 글자(정산서 창) 또는 수(BOM). 고칠 때는 받은 그대로 보여 준다(「25.」 를 치는 중에 점이 사라지지 않게) */
  value: string | number;
  onChange: (v: string) => void;
  className: string;
  ariaLabel?: string;
}) {
  const [focused, setFocused] = useState(false);
  const text = String(value);
  const n = Number(value);
  const shown = focused || text.trim() === '' || !Number.isFinite(n) ? value : String(+n.toFixed(2));
  return (
    <input
      type="number"
      step="any"
      value={shown}
      title={text.trim() === '' ? undefined : `${text}%`}
      aria-label={ariaLabel}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
      onChange={(e) => onChange(e.target.value)}
      className={className}
    />
  );
}
